import ServiceBase from './serviceBase';
import { FlowCommentCreate, FlowCommentsFilter, FlowCommentList } from './types/Flow';

class OperInitialEsrsCommentsService extends ServiceBase {
  create = async (data: FlowCommentCreate): Promise<void> =>
    this.post<void>('initialEsrsComment/create', data);

  getList = async (filter: FlowCommentsFilter): Promise<FlowCommentList> =>
    this.post<FlowCommentList>('initialEsrsComment/list', filter);

  exportExcel = async (operationId: number): Promise<boolean> => {
    await this.download(`initialEsrsComment/excel/${operationId}`, undefined, true);
    return true;
  };
}

const operInitialEsrsCommentsService = new OperInitialEsrsCommentsService();

export default operInitialEsrsCommentsService;
